import Box from '@zenbusiness/zui/Box';
import Card from '@zenbusiness/zui/Card';
import { superstyled } from '@zenbusiness/zui/styles';
import Text from '@zenbusiness/zui/Text';

export const PaymentOrderInfoRoot = superstyled({
  name: 'PaymentOrderInfo',
  slot: 'root',
  tag: Card,
  propsAdded: {
    color: 'paper',
    variant: 'outlined',
  },
  styles: ({ theme }) => ({
    padding: theme.spacing(2.5),
  }),
});

export const PaymentOrderInfoBlockquote = superstyled({
  name: 'PaymentOrderInfo',
  slot: 'blockquote',
  tag: Box,
  styles: ({ theme }) => ({
    position: 'relative',
    paddingLeft: theme.spacing(2),
    '&::before': {
      content: '""',
      position: 'absolute',
      left: 0,
      top: 0,
      bottom: 0,
      width: 3,
      borderRadius: 2,
      backgroundColor: theme.palette.primary.main,
    },
  }),
});

export const PaymentOrderInfoTitle = superstyled({
  name: 'PaymentOrderInfo',
  slot: 'title',
  tag: Text,
  propsAdded: {
    size: 'sm',
    weight: 'medium',
  },
  styles: ({ theme }) => ({
    marginBottom: theme.spacing(0.5),
  }),
});

export const PaymentOrderInfoDescription = superstyled({
  name: 'PaymentOrderInfo',
  slot: 'description',
  tag: Text,
  propsAdded: {
    color: 'secondary',
    component: 'p',
    size: 'sm',
  },
});
